__turbopack_context__.v({
  "Dropdown": "BlockSideNav-module__bXPQ1W__Dropdown",
  "DropdownToggle": "BlockSideNav-module__bXPQ1W__DropdownToggle",
  "Sidebar": "BlockSideNav-module__bXPQ1W__Sidebar",
  "blockText": "BlockSideNav-module__bXPQ1W__blockText",
  "groupContent": "BlockSideNav-module__bXPQ1W__groupContent",
  "sideColumn": "BlockSideNav-module__bXPQ1W__sideColumn",
  "sidebar__content": "BlockSideNav-module__bXPQ1W__sidebar__content",
  "subItem": "BlockSideNav-module__bXPQ1W__subItem",
  "subitems_navigations": "BlockSideNav-module__bXPQ1W__subitems_navigations",
  "text-justify": "BlockSideNav-module__bXPQ1W__text-justify",
});
